/**
 * 查询订单详情
 */

import { fetchData } from '@umu/umu-fetch';
import { IResponse } from '@umu/umu-types';
import { ShoppingCartAPI } from 'market/@marketCommon/api/order';

interface IOutput {
    num: number;
}

export const getShoppingCartCount = (): Promise<IResponse<IOutput>> => {
    return fetchData(ShoppingCartAPI.GET_SHOPPING_CART_COUNT).then((res: IResponse<IOutput>) => {
        return res;
    });
};
